<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import type { VForm } from '@/@types/types';
import { onMounted, useSlots, inject } from 'vue';

import { VTextField } from 'vuetify/lib/components';

interface STextFieldProps {
  eagerlyValidate?: boolean;
  rules?: any[];
}
const props = defineProps({
  eagerlyValidate: { type: Boolean, default: false },
  rules: { default: () => [] }
});

const vuetifyForm = inject<VForm | null>('form', null);

const slots = useSlots();

const textField = _ref<(InstanceType<typeof VTextField> & { validate: () => boolean }) | null>(null);

const hasPrependText = _computed(() => !!slots['prepend-text']);

onMounted(() => {
  if (props.eagerlyValidate) {
    vuetifyForm?.validate();
  }
});

</script>

<template lang="pug">
v-text-field(
  ref="textField"
  v-bind="$attrs"
  v-on="$listeners"
  data-track="s-text-field"
  outlined dense
  :clearable="!['false', false].includes($attrs.clearable)"
  :rules="rules")

  template( #prepend-inner )
    .v-text-field__prependText-inner( v-if="hasPrependText" )
      slot( name="prepend-text" )

  template( #append-outer )
    slot( name="append-outer" )

</template>

<style lang="scss" scoped>
:deep(.v-text-field__prependText-inner) {
  z-index: 1;
  background-color: var(--v-bgPageSecondary-base);
  position: relative;
  margin-top: -6px;
  margin-left: -10px;
  margin-right: 7px;
  padding: 11px 11px 0;
  height: 32px;
  color: var(--v-textSecondary-base);
  border-radius: 4px 0 0 4px;
}

// By default, vuetify adds a margin on .v-input__append-outer so we remove it to allow for more composability and less magic
.v-text-field :deep(.v-input__append-outer) {
  margin-top: 0 !important;
}
</style>
